import { ShellBar as UIShellBar } from '@ui5/webcomponents-react';
// eslint-disable-next-line no-restricted-imports
import styled from 'styled-components';

export const ShellBar = styled(UIShellBar)`
    &&::part(root) {
    background-color: transparent;
  }`;